import {
    BankCustodian,
    AvidiaPartnersState,
    AvidiaPartner
} from "@/admin/types";
import {
    FetchState
} from "@/shared/types";
import Vue from "vue";
import * as bankService from "@/shared/api/bankService";
import * as storeHelper from "@/shared/storeHelper";
import { defineStore } from "pinia";
import _ from "lodash";

export const initialState: AvidiaPartnersState = {
    partners: {}
};

const defaultPartnerItem = () => ({
    fetchState: FetchState.Uninitialized,
    avidiaPartner: null
});

export const useAvidiaPartnerStore = defineStore("avidiaPartner", {
    state: (): AvidiaPartnersState => (_.cloneDeep(initialState)),
    getters: {
        custodiansAllowingManagement: state => [ BankCustodian.Avidia ],
        canManageBranchAndCostCenter () {
            return (custodian: BankCustodian) => {
                return this.custodiansAllowingManagement.some(c => c === custodian);
            };
        },
        isLoadingPartnerBranchAndCostCenter: state => (partnerId: number) => {
            const item = state.partners[partnerId];
            return item && item.fetchState === FetchState.Loading;
        },
        didLoadPartnerBranchAndCostCenter: state => (partnerId: number) => {
            const item = state.partners[partnerId];
            return item && item.fetchState === FetchState.Loaded;
        },
        partnerBranchAndCostCenter: state => (partnerId: number) => {
            const item = state.partners[partnerId];
            return item ? item.avidiaPartner : null;
        },
    },
    actions: {
        setPartnerFetchState ({ partnerId, fetchState }: { partnerId: number, fetchState: FetchState }) {
            if (!this.partners[partnerId]) {
                Vue.set(this.partners, partnerId, defaultPartnerItem());
            }
            this.partners[partnerId].fetchState = fetchState;
        },
        setPartnerBranchAndCostCenter ({ partnerId, avidiaPartner }: {
            partnerId: number, avidiaPartner: AvidiaPartner
        }) {
            if (!this.partners[partnerId]) {
                this.partners[partnerId] = defaultPartnerItem();
            }
            this.partners[partnerId].avidiaPartner = avidiaPartner;
        },
        getPartnerBranchAndCostCenter (partnerId: number): Promise<any> {
            if (this.partners[partnerId] && this.partners[partnerId].fetchState !== FetchState.Uninitialized) {
                return Promise.resolve();
            }
            this.setPartnerFetchState({ partnerId, fetchState: FetchState.Loading });
            return bankService.getAvidiaPartner(partnerId)
                .then(response => {
                    this.setPartnerBranchAndCostCenter({
                        partnerId,
                        avidiaPartner: response.data
                    });
                    this.setPartnerFetchState({ partnerId, fetchState: FetchState.Loaded });
                })
                .catch(err => {
                    this.setPartnerFetchState({ partnerId, fetchState: FetchState.Uninitialized });
                    return storeHelper.handleError({ error: err, rethrow: true });
                });
        },
        beginSetPartnerBranchAndCostCenter (request: AvidiaPartner): Promise<any> {
            return bankService.saveAvidiaPartner(request)
                .catch(err => {
                    return storeHelper.handleError({ error: err, rethrow: true });
                });
        }
    }
});